import React, { useContext, useEffect, useRef, useState } from "react";
import EquipmentButtonIcons from "../../../constants/EquipmentButtonIcon";
import "./Key.css";
import { Context } from "../../../context/Context";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Key = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  setData,
}) => {
  const { equipmentButtons, devices } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({ equipment_id }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickButton = (button, icon) => {
    setSelectedButton({
      id: button.id,
      icon,
      state:
        selectedButton && selectedButton.id == button.id
          ? selectedButton.state
            ? 0
            : 1
          : 1,
    });
  };

  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.id);
    const device = devices.find((d) => d.id == button.device_id);
    if (!device && isNaN(button.digit)) {
      return;
    }
    let data1 = Number(button.digit) + 1;
    let data2 = selectedButton.state;
    setData({
      icon: selectedButton.icon,
      name: button.name,
      data: [2, data1, data2],
      device: device,
    });
    setSelectedButton(null);
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      let iconPath = "/assets/img/app-icons/sg8.png";
      let iconId = 1;
      if (button.icon) {
        let buttonIcon = EquipmentButtonIcons.find(
          (icon) => icon.id == button.icon
        );
        iconPath = buttonIcon.path;
        iconId = buttonIcon.id;
      }
      return (
        <div
          key={button.id}
          className="key"
          onClick={() => handleClickButton(button, iconId)}
        >
          <div className="icon-part">
            <img src={iconPath} alt="" />
          </div>
          <div
            className={
              selectedButton && selectedButton.id == button.id
                ? selectedButton.state
                  ? "status-part bg-success"
                  : "status-part bg-danger"
                : "status-part"
            }
          ></div>
          <div className="info-part">
            <p className="text-center p-0 m-0 d-block">{button.name}</p>
            <p className="text-center p-0 m-0" style={{fontSize: '11px'}}>
              C{button.digit + 1}-S/
              {devices.find((d) => d.id == button.device_id)?.serial}
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3"
        style={{ zIndex: 1, top: '0' }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
          <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">{renderButtons()}</div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Key);
